"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const forms_1 = __importDefault(require("./forms"));
const Meli = {
    Forms: forms_1.default,
};
if (window && !window.Meli) {
    window.Meli = Meli;
    const me = document.querySelector('script[data-meli-init]');
    if (!me || me.getAttribute('data-meli-init') !== 'false') {
        // eslint-disable-next-line no-console
        Meli.Forms.init().catch(console.error);
    }
}
module.exports = Meli;
